// extracted by mini-css-extract-plugin
module.exports = {"mCard":"nc-z","image":"oc-z","imageNoBackground":"pc-z"};